var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-card",
    {
      staticClass: "mt-3",
      attrs: {
        title:
          _vm.$t("apeironGwApp.buscadorPersonasMorales.card.sede").toString() +
          ": " +
          _vm.institucion.nombreSede,
      },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "10" } },
            [
              _c(
                "b-row",
                { staticClass: "my-1" },
                [
                  _c("b-col", { staticClass: "text-right" }, [
                    _c("strong", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm
                              .$t(
                                "apeironGwApp.buscadorPersonasMorales.card.noDeRegistro"
                              )
                              .toString() + ":"
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _vm.institucion.noDeRegistro
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.institucion.noDeRegistro),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.institucion.noDeRegistro
                        ? _c("b-badge", { attrs: { variant: "danger" } }, [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm
                                    .$t(
                                      "apeironGwApp.buscadorPersonasMorales.mensajes.sinNoDeRegistro"
                                    )
                                    .toString()
                                ),
                              },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-right" }, [
                    _c("strong", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm
                              .$t(
                                "apeironGwApp.buscadorPersonasMorales.card.rfc"
                              )
                              .toString() + ":"
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.institucion.rfc) },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "my-1" },
                [
                  _c("b-col", { staticClass: "text-right" }, [
                    _c("strong", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm
                              .$t(
                                "apeironGwApp.buscadorPersonasMorales.card.entidadFederativa"
                              )
                              .toString() + ":"
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.institucion.entidadFederativa),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-right" }, [
                    _c("strong", [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm
                              .$t(
                                "apeironGwApp.buscadorPersonasMorales.card.municipio"
                              )
                              .toString() + ":"
                          ),
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.institucion.municipio),
                      },
                    }),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "my-1", attrs: { "align-h": "start" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { cols: "3" } },
                    [
                      _c("strong", [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm
                                .$t(
                                  "apeironGwApp.buscadorPersonasMorales.card.sector"
                                )
                                .toString() + ":"
                            ),
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.institucion.sector) },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.seleccionarSoloSede
            ? _c(
                "b-col",
                { staticClass: "text-right pr-5" },
                [
                  _vm.institucion.noDeRegistro
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.top.left",
                              value: _vm.$t(
                                "apeironGwApp.buscadorPersonasMorales.mensajes.seleccionarSede"
                              ),
                              expression:
                                "$t('apeironGwApp.buscadorPersonasMorales.mensajes.seleccionarSede')",
                              modifiers: { hover: true, top: true, left: true },
                            },
                          ],
                          attrs: { variant: "outline" },
                          on: {
                            click: function ($event) {
                              return _vm.seleccionarSinSubsede()
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "check-circle-fill",
                              variant: "success",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.generarSedeComoSubsede &&
      _vm.institucion.subsdes.length == 1 &&
      _vm.institucion.subsdes[0]?.esLaSede
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(
                            "apeironGwApp.buscadorPersonasMorales.mensajes.sedeSinSubsedes"
                          )
                        ),
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "my-2 mx-2 area-responsive area-responsive-tabla" },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  bordered: "",
                  small: "",
                  "head-variant": "dark",
                  items: _vm.institucion.subsdes,
                  fields: _vm.fieldsSubsedes,
                  "show-empty": "",
                  "empty-text": _vm.$t(
                    "apeironGwApp.buscadorPersonasMorales.mensajes.sinRegistros"
                  ),
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(acciones)",
                    fn: function (data) {
                      return [
                        _vm.institucion.noDeRegistro && data.item.noDeRegistro
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.left",
                                    value: _vm.$t(
                                      "apeironGwApp.buscadorPersonasMorales.mensajes.seleccionarSubsede"
                                    ),
                                    expression:
                                      "$t('apeironGwApp.buscadorPersonasMorales.mensajes.seleccionarSubsede')",
                                    modifiers: { hover: true, left: true },
                                  },
                                ],
                                attrs: { variant: "outline" },
                                on: {
                                  click: function ($event) {
                                    return _vm.seleccionarConSubsede(data.item)
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "check-circle-fill",
                                    variant: "success",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.institucion.subsdes.length,
                  "per-page": _vm.perPage,
                  "aria-controls": "my-table",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }